// extracted by mini-css-extract-plugin
module.exports = {"hamburger-react-big":"styles_hamburger-react-big__cWbUS","hamburger-react-small":"styles_hamburger-react-small__YE4S_"};